import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import store from './store/index'

Vue.config.productionTip = false
Vue.prototype.baseUrl = process.env.NODE_ENV === 'production' ? 'https://www.fulizhushou.cn/' : 'http://fuli.daishujiankang.com/';
Vue.prototype.showUrl = process.env.NODE_ENV === 'production' ? 'www.fulizhushou.cn' : 'fuli.daishujiankang.com';

new Vue({
  router,
  store,
  render: h => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
}).$mount('#app')
